import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import {
    userLoginReducer,
    userRegisterReducer,
    userProfileReducer,
    userTourReducer,
    onboardFirstStepReducer,
    onboardSecondStepReducer,
    onboardThirdStepReducer,
    onboardFinalStepReducer,
    paymentCheckoutReducer,
    paymentValidateReducer
} from './reducers/userReducers';

import {
    linkedinAdGenerateReducer,
    taglineGenerateReducer,
    googleAdGenerateReducer,
    amazonDescGenerateReducer,
    blogOutlineGenerateReducer,
    blogIdeasGenerateReducer,
    blogQuoteGenerateReducer,
    blogIntroGenerateReducer,
    displayAdsGenerateReducer,
    FaqGenerateReducer,
    painAgitateGenerateReducer,
    facebookAdGenerateReducer
} from './reducers/generateReducer';

import {
    allWorkspacesReducer,
    currentWorkSpaceReducer,
    workspaceCreateInitialReducer,
    workspaceCreateReducer,
    workspaceEditReducer
} from './reducers/workspaceReducer';

import {
    allProjectsReducer,
    createProjectReducer,
    allRecentFilesReducer,
    allFilesReducer,
    allBookmarkFilesReducer,
    folderRenameReducer,
    createFileReducer,
    fileEditReducer,
    fileDeleteReducer,
    fileRenameReducer,
    fileDuplicateReducer,
    fileMoveReducer
} from './reducers/projectReducers';

const reducer = combineReducers({
    //user reducers
    userLogin: userLoginReducer,
    userRegister: userRegisterReducer,
    userProfile: userProfileReducer,
    userTour: userTourReducer,
    onboardFirstStep: onboardFirstStepReducer,
    onboardSecondStep: onboardSecondStepReducer,
    onboardThirdStep: onboardThirdStepReducer,
    onboardFinalStep: onboardFinalStepReducer,
    paymentCheckout: paymentCheckoutReducer,
    paymentValidate: paymentValidateReducer,

    //generation reducers
    linkedinAdGenerate: linkedinAdGenerateReducer,
    taglineGenerate: taglineGenerateReducer,
    googleAdGenerate: googleAdGenerateReducer,
    amazonDescGenerate: amazonDescGenerateReducer,
    blogOutlineGenerate: blogOutlineGenerateReducer,
    blogIdeasGenerate: blogIdeasGenerateReducer,
    blogQuoteGenerate: blogQuoteGenerateReducer,
    blogIntroGenerate: blogIntroGenerateReducer,
    displayAdsGenerate: displayAdsGenerateReducer,
    FaqGenerate: FaqGenerateReducer,
    painAgitateGenerate: painAgitateGenerateReducer,
    facebookAdGenerate: facebookAdGenerateReducer,


    //workspace reducers
    allWorkspaces: allWorkspacesReducer,
    currentWorkSpace: currentWorkSpaceReducer,
    workspaceCreateInitial: workspaceCreateInitialReducer,
    workspaceCreate: workspaceCreateReducer,
    workspaceEdit: workspaceEditReducer,

    //project reducers
    allProjects: allProjectsReducer,
    createProject: createProjectReducer,
    allRecentFiles: allRecentFilesReducer,
    allBookmarkFiles: allBookmarkFilesReducer,
    folderRename: folderRenameReducer,
    allFiles: allFilesReducer,
    createFile: createFileReducer,
    fileEdit: fileEditReducer,
    fileDelete: fileDeleteReducer,
    fileRename: fileRenameReducer,
    fileDuplicate: fileDuplicateReducer,
    fileMove: fileMoveReducer
})

const userInfoFromStorage = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null
// const linkeinAdFromStorage = localStorage.getItem('linkedinAd') ? JSON.parse(localStorage.getItem('linkedinAd')) : null
// const taglineFromStorage = localStorage.getItem('tagline') ? JSON.parse(localStorage.getItem('tagline')) : null
// const googleAdFromStorage = localStorage.getItem('googleAd') ? JSON.parse(localStorage.getItem('googleAd')) : null
// const amazonDescFromStorage = localStorage.getItem('amazondesc') ? JSON.parse(localStorage.getItem('amazondesc')) : null

const initialState = {
    userLogin: { userInfo: userInfoFromStorage },
    // linkedinAdGenerate: { linkedInAddDetails: linkeinAdFromStorage?.resultData, companyName: linkeinAdFromStorage?.companyName },
    // taglineGenerate: { taglineDetails: taglineFromStorage?.resultData, companyName: taglineFromStorage?.companyName },
    // googleAdGenerate: { googleAddDetails: googleAdFromStorage?.descriptions, googleAddHeadlines: googleAdFromStorage?.headlines, websiteURL: googleAdFromStorage?.websiteURL },
    // amazonDescGenerate: { amazonDescDetails: amazonDescFromStorage?.resultData }
}

const middleware = [thunk]

const store = createStore(reducer, initialState, composeWithDevTools(applyMiddleware(...middleware)))

export default store